import { Component, OnInit, signal } from '@angular/core';
import { WhitelabelService } from '../../services/whitelabel.service';
import { PendingWhitelabelConfiguration, WhitelabelConfiguration} from '../../models/whitelabel-config';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { WhitelabelPendingAppConfirmConfigComponent } from '../whitelabel-pending-app-confirm-config/whitelabel-pending-app-confirm-config.component';

@Component({
  standalone: false,
  selector: 'app-whitelabel-pending-apps-list',
  templateUrl: './whitelabel-pending-apps-list.component.html',
  styleUrls: ['./whitelabel-pending-apps-list.component.css']
})
export class WhitelabelPendingAppsListComponent implements OnInit {

  public readonly whitelabelPendingApps = signal<PendingWhitelabelConfiguration[]>([])

  public readonly loading = signal(false);

  public searchBarContent: string | null = null;

  constructor(private whitelabelService: WhitelabelService, private toastrService: ToastrService, private modalService: MatDialog) {}

  public openInitConfigModal(pendingApp: PendingWhitelabelConfiguration): void {
    this.modalService.open(WhitelabelPendingAppConfirmConfigComponent, {
      data: {
        accountantName: pendingApp.accountantName
      },
      maxWidth: '30%'
    }).afterClosed().subscribe({
      next: (data: { confirm: boolean} | null) => {
        if (!data) return;

        const whitelabelConfiguration = new WhitelabelConfiguration({
          accountantId: pendingApp.accountantId,
          name: pendingApp.accountantName,
          isDraft: true,
          ios: pendingApp.hasIos ? {
            apiKeyId: null,
            apiKeyIssuerId: null,
            apiTokenBase64: null,
            appId: null,
            applicationGroup: null,
            developmentTeam: null,
            files: null,
            iosBundleId: null,
            oneSignal: null,
            provisionProfileSpecifier: null,
            iosCertificateExpiryDate: '',
            status: 0
          } : null,
          android: pendingApp.hasAndroid ? {
            serviceAccountEmail: null,
            serviceAccountPrivateKey: null,
            sha256CertificateFingerPrint: null,
            androidPackageName: null,
            files: null,
            status: 0
          } : null,
          deepLink: null,
          oneSignal: null,
          styles: null,
          versions: null,
        });

        this.whitelabelService.saveConfigurations(whitelabelConfiguration).subscribe({
          next: () => {
            this.toastrService.success('Configuração salva com sucesso');

            // Antes daqui havia `findIndex(pendingApp => pendingApp.accountantId === pendingApp.accountantId)`
            // seguido de splice: o parametro do arrow sombreava o do metodo, a comparacao
            // era sempre true e o item removido acabava sendo o primeiro da lista, nao o
            // que foi salvo. Filtrar pelo accountantId externo remove o correto -- e
            // trocar a referencia do array e o que faz o signal notificar o template.
            this.whitelabelPendingApps.update(current =>
              current.filter(app => app.accountantId !== pendingApp.accountantId));
          }
        })
      }
    })
  }

  ngOnInit(): void {
    this.loading.set(true);

    this.whitelabelService.getPendingConfigurations().subscribe({
      next: (configurations) => {
        this.whitelabelPendingApps.set(configurations);
        this.loading.set(false);
      },
      error: () => {
        this.loading.set(false);
        this.toastrService.error('Ocorreu um erro na sua requisição');
      }
    })
  }
}
